/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { of as observableOf, Observable } from 'rxjs';
import { MeteostationsApi } from '../api/meteostations.api';
import { MeteostationsData, MeteostationsValue } from '../../../interfaces/solar/meteostations';

@Injectable()
export class MeteostationsService extends MeteostationsData {
/*
  "value": {
      "dt": "2019-12-19T08:25:00.000Z",
      "PVTemp": 8.6,
      "AmpTemp": 8.3,
      "Radiation": 557
  }
*/
  private data: MeteostationsValue[] = [
    {
      dt: '2019-12-19T08:25:00.000Z',
      PVTemp: 8.6,
      AmpTemp: 8.3,
      Radiation: 557,
    },
  ];

  constructor(private api: MeteostationsApi) {
    super();
  }

  getTodayData(params): Observable<MeteostationsValue[]> {
    return this.api.getTodayData(params);
    // return this.api.list();
    // return observableOf(this.data);
  }

  getAvgRadiationEnergy(params): Observable<MeteostationsValue[]> {
    return this.api.getAvgRadiationEnergy(params);
    // return this.api.list();
    // return observableOf(this.data);
  }

  getRadiationEnergyByDate(params): Observable<any> {
    return this.api.getRadiationEnergyByDate(params);
  } 
  // list(): Observable<Facility[]> {
  //   // return this.api.list();
  //   return observableOf(this.data);
  // }
}
